import React, {MutableRefObject} from 'react';
import {Button, Icon} from '@mc/ui-v4';
import {mcMapPosition} from '@mc/react-ui-icons';
import {EditorToolType, MapEditorActions} from '@mc/react-mapio';
import {useAppConfig} from '@mc/react-app-base';
import {useIsMobile} from '../../../hooks/useIsMobile';
import './GeolocationButton.scss';

type Props = {
    mapRef: MutableRefObject<MapEditorActions>;
    disabled?: boolean;
    round?: boolean;
};

export const GeolocationButton: React.FC<Props> = ({mapRef, disabled, round}) => {
    const isMobile = useIsMobile();
    // @ts-ignore
    const {serverPublic} = useAppConfig();

    // Tlačítko stojí pod vyhledáváním, proto přebírá jeho vzhled: na mobilu bílý podklad
    // (v public režimu kolečko), na desktopu box sjednocený se zoomem.
    const wrapperClass = round
        ? 'overhead-round-btn'
        : `geolocation-wrapper ${isMobile ? 'mobile' : ''} ${serverPublic ? 'public' : ''}`;

    return (
        <div className={`${wrapperClass} drop-shadow`}>
            <Button
                style="link"
                noFocus
                disabled={disabled}
                title="Moje poloha"
                onClick={() => mapRef.current?.activateToolWithType(EditorToolType.GEOLOCATION)}
                icon={<Icon intent={'primary'} icon={mcMapPosition} />}
            />
        </div>
    );
};
